import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hero-carousel__play-pause" }
const _hoisted_2 = {
  key: 0,
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = {
  key: 1,
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    ($props.isPause)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("rect", {
            width: "18",
            height: "18",
            fill: "none"
          }, null, -1),
          _createElementVNode("path", {
            d: "M4 1V17",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round"
          }, null, -1),
          _createElementVNode("path", {
            d: "M14 1V17",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round"
          }, null, -1)
        ])))
      : (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[1] || (_cache[1] = [
          _createElementVNode("rect", {
            width: "18",
            height: "18",
            fill: "none"
          }, null, -1),
          _createElementVNode("path", {
            d: "M15.6593 8.32046L15.6617 8.32187C16.1116 8.57872 16.1143 9.19375 15.6606 9.45364L15.6594 9.45428L3.08767 16.6762L3.08631 16.677C2.57055 16.9743 2 16.5846 2 16.1093V1.66201C2 1.35002 2.14368 1.17828 2.34458 1.0813C2.58459 0.965437 2.88068 0.97634 3.08749 1.09505C3.08755 1.09509 3.08761 1.09512 3.08767 1.09515L15.6593 8.32046Z",
            stroke: "currentColor",
            "stroke-width": "2"
          }, null, -1)
        ])))
  ]))
}